module.exports = __webpack_public_path__ + "img/newbanner.20ce763f.png";